'use client';

import { Box, Chip, MenuItem, Typography } from '@mui/material';

type WalletOption = {
  address: string;
  label: string;
  walletType: 'privy_embedded' | 'external';
};

interface ActiveTradingWalletSelectorProps {
  wallets: WalletOption[];
  activeWalletAddress?: string;
  isSwitching: boolean;
  onSelectWallet: (wallet: WalletOption) => void;
}

const truncateAddress = (address: string) => `${address.slice(0, 6)}...${address.slice(-4)}`;

export function ActiveTradingWalletSelector({
  wallets,
  activeWalletAddress,
  isSwitching,
  onSelectWallet,
}: ActiveTradingWalletSelectorProps) {
  if (wallets.length <= 1) return null;

  return (
    <Box sx={{ px: 1, pb: 0.5 }}>
      <Typography
        variant="caption"
        sx={{ px: 1, pb: 0.75, display: 'block', color: 'text.secondary', fontWeight: 600 }}
      >
        Active Trading Wallet
      </Typography>
      {wallets.map((wallet) => {
        const isActive = wallet?.address?.toLowerCase() === activeWalletAddress?.toLowerCase();
        return (
          <MenuItem
            key={wallet.address}
            disabled={isSwitching}
            onClick={() => onSelectWallet(wallet)}
            sx={{
              py: 0.85,
              px: 1.75,
              borderRadius: '10px',
              mx: 0,
              mb: 0.5,
              justifyContent: 'space-between',
            }}
          >
            <Box>
              <Typography variant="body2" sx={{ fontWeight: 500, color: 'text.primary' }}>
                {wallet.label}
              </Typography>
              <Typography
                variant="caption"
                sx={{ color: 'text.secondary', fontFamily: 'monospace', display: 'block' }}
              >
                {truncateAddress(wallet.address)}
              </Typography>
            </Box>
            {isActive && <Chip size="small" label="Active" color="primary" />}
          </MenuItem>
        );
      })}
    </Box>
  );
}

export default ActiveTradingWalletSelector;
